import { isWorkerEnvironment } from '@openobserve/browser-core';
export function buildCommonContext() {
    if (isWorkerEnvironment) {
        return {};
    }
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
    };
}
//# sourceMappingURL=commonContext.js.map